import React, { useContext, useEffect, useRef, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { LogInSchoolID, origin } from '../../JS/Common';
import { ApiPostCall } from '../../JS/Connector';
import AlertsComp from '../../Components/AlertsComp';
import { UserContext } from '../../App';
import AlertPopup from '../../Components/AlertPopup';
import { setSupportTicketDetails } from '../../Store/Slices/authSlice';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import useConfig from '../../Hooks/useConfig';
import SettingBoxWrapper from './SettingBoxWrapper';


export default function Helpdeskdetails({ setLoading, setNewAlerts }) {
    const { small_student, small_staff_members, manager, specific_school, specific_support_ticket_text } = useConfig();
    const StateData = useSelector((state) => state.authData);
    const reduxDispatch = useDispatch();
    const { UserData, setUserData } = useContext(UserContext);
    const [GoogleSSOFlag, setGoogleSSOFlag] = useState(UserData.ssoFlag)
    const [showcopymsg, setshowcopymsg] = useState(false);
    const [RevertHelpdeskPopup, setRevertHelpdeskPopup] = useState(false);
    const labelRef = useRef(null);
    var schoolnumber = StateData?.Schoolnumber
    useEffect(() => {
        setGoogleSSOFlag(UserData.ssoFlag)
    }, [UserData.ssoFlag])
    const handleCopyClick = () => {
        if (labelRef.current) {
            const labelValue = labelRef.current.innerText;
            navigator.clipboard.writeText(labelValue);
            setshowcopymsg(true);
            setTimeout(() => setshowcopymsg(false), 2000);
        }
    };
    async function updateSSOSetting() {
        setLoading(true)
        reduxDispatch(setSupportTicketDetails(null));
        var raw = JSON.stringify({
            schoolId: LogInSchoolID,
            flag: GoogleSSOFlag
        })
        await ApiPostCall("/settings/sso/set-for-school", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                if (result == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"Help Desk Setting Updated Successfully"} />);
                    setTimeout(() => {
                        setUserData((prevUserData) => ({ ...prevUserData, ssoFlag: GoogleSSOFlag }));
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 1500);
                }
                else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }
    async function FuncRevertHelpdesk() {
        setLoading(true)
        var raw = JSON.stringify({
            schoolId: LogInSchoolID,
            helpdeskFlag: 1
        })
        await ApiPostCall("/helpdesk/revert", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                if (result == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"Help Desk revert successfully!"} />);
                    setTimeout(() => {
                        setRevertHelpdeskPopup(false)
                        setUserData((prevUserData) => ({ ...prevUserData, helpdeskUpdatedFlag: null }));
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 1500);
                }
                else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }
    const renderCopyMessage = () => (
        showcopymsg && <label className="pt-2" style={{ color: "var(--primary-color)", fontSize: "15px" }}>Copied!</label>
    );
    const renderSSOSetting = () => (
        <div className="p-1 pe-0 mt-1 pt-3">
            <label>Enable SSO for help desk form? (Checks for email domains that exist in your account, and uses your primary SSO option.) </label>
            <div className='col-md-12 mt-3 d-flex align-items-center'>
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        name='googlesso'
                        onChange={() => setGoogleSSOFlag(1)}
                        defaultChecked={GoogleSSOFlag == 1}
                    />
                    <label className="form-check-label">Yes</label>
                </div>
                <div className="form-check ms-5">
                    <input
                        className="form-check-input"
                        type="radio"
                        name='googlesso'
                        onChange={() => setGoogleSSOFlag(0)}
                        defaultChecked={GoogleSSOFlag != 1}
                    />
                    <label className="form-check-label">No</label>
                </div>
                <div className="ps-5">
                    <button className="SaveBtn" onClick={updateSSOSetting}>Confirm</button>
                </div>
            </div>
        </div>
    );
    const renderRevertOption = () => (
        <div className="p-1 pe-0 mt-1 pt-3">
            <label className='pe-3'>Revert to simple Help Desk? </label>
            <button className="SaveBtn" onClick={() => setRevertHelpdeskPopup(true)}>Revert</button>
        </div>
    );
    const renderHelpdeskUrl = () => (
        <div className="p-1 pe-0 mt-3 d-flex align-items-center">
            <label ref={labelRef} style={{ wordBreak: 'break-all' }}>
                <b>{origin}{UserData.helpdeskUpdatedFlag == null ? `/tickets/${schoolnumber}` : `/helpdesk-request/${schoolnumber}`}</b>
            </label>
            <FontAwesomeIcon icon={faCopy} style={{ height: "20px" }} className='cursor-pointer ps-3' title='Click to copy this URL' onClick={handleCopyClick} />
        </div>
    );
    return (
        <>
            <SettingBoxWrapper
                BoxTitle={UserData.helpdeskUpdatedFlag == null ? 'Support Ticket URL' : 'Help Desk Ticket URL'}
                BoxLabel={UserData.helpdeskUpdatedFlag == null ?
                    specific_support_ticket_text
                    :
                    "Since you're now using the advanced Help Desk, the old support ticket system is no longer available. You can access the Help Desk through this URL:"
                }
                labelCustomClass={'text-justify'}
                addMarginTop={false}
            >
                {renderHelpdeskUrl()}
                <div className='col-12 text-center'>
                    {renderCopyMessage()}
                </div>
                {UserData.helpdeskUpdatedFlag == null ? renderSSOSetting() : renderRevertOption()}
            </SettingBoxWrapper>

            <AlertPopup isshow={RevertHelpdeskPopup} img={'/images/redInfo.svg'}
                headingtext={`Are you sure?`} text={'Reverting to simple Help Desk will remove any configuration you have made on advanced Help Desk. Are you sure you want to revert?'}
                cancelcall={(e) => setRevertHelpdeskPopup(false)}
                canceltext={"No"} successtext={"Yes, Revert It!"} successcall={FuncRevertHelpdesk} btntype={'deleteBtn'} />
        </>
    )
}
